<template lang="pug">
    // V2: 調整
    // 1. 支援多組數據
    // 2. 新增fillChartData功能, 使之用法和其他圖表一致
    // 3. 繪圖參數為 { data: { datasets: [], labels: '' } }
    // 4. 不相容舊版, 只接受新的使用方式
    // 5. 為加速開發; 暫時沒有自主獲取數據的功能
    div.container
        template(v-for="(dataset, index) in chartData.datacollection.datasets")
            // p {{ dataset }}
            Row.center
                template(v-for="(num, index) in dataset.data")
                    Col(:span="colSpan(dataset.data.length)" style="text-align: center")
                        template(v-if="withCard")
                            Card.card-shadow
                                template(v-if="textInSingleLine")
                                    p(v-resize-text="{ratio:0.2, minFontSize: minFontSize, maxFontSize: maxFontSize, delay: 200}" style='margin-top: 20px;') {{ chartData.datacollection.labels[index] }}: {{ formatNumToString(num) }}
                                template(v-else)
                                    p(v-resize-text="{ratio:0.5, minFontSize: minFontSize, maxFontSize: maxFontSize, delay: 200}") {{ formatNumToString(num) }}
                                    p {{ chartData.datacollection.labels[index] }}

                        template(v-else)
                            template(v-if="textInSingleLine")
                                p(v-resize-text="{ratio:0.5, minFontSize: minFontSize, maxFontSize: maxFontSize, delay: 200}" style='margin-top: 20px;') {{ chartData.datacollection.labels[index] }}: {{ formatNumToString(num) }}
                            template(v-else)
                                p(v-resize-text="{ratio:0.5, minFontSize: minFontSize, maxFontSize: maxFontSize, delay: 200}") {{ formatNumToString(num) }}
                                p(style="word-break: break-word; padding: 0 10px") {{ chartData.datacollection.labels[index] }}
        Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";
import numeral from "numeral";
import ResizeText from "vue-resize-text";

export default {
    name: "SingleNumWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "chartTitle" },
        numeralFormat: { type: String, default: "0.00a" },
        decimalPlaces: { type: Number, default: 2 },
        numStringPrefix: { type: String, default: "" },
        numStringSuffix: { type: String, default: "" },

        withCard: { type: Boolean, default: true },
        textInSingleLine: { type: Boolean, default: false },
        minFontSize: { type: String, default: "32px" },
        maxFontSize: { type: String, default: "52px" },

        isGetDataFromStore: { type: Boolean, default: false },

        givenChartData: { type: Object, default: () => ({}) }
    },
    directives: {
        ResizeText
    },
    created() {},
    beforeDestroy() {},
    data() {
        return {
            spinShow: false,
            // num: "",
            // formatString: "",
            // nginxData: { data: { datasets: [], labels: "" } },
            chartData: {
                datacollection: { labels: [], datasets: [] },
                options: {}
            }
        };
    },
    methods: {
        colSpan(dataLenth) {
            let span = Math.floor(24 / dataLenth);
            return span < 4 ? 4 : span;
            //     console.log(dataLenth)
            // return 6;
        },
        formatNumToString(num) {
            let formatedNum = parseFloat(num).toFixed(this.decimalPlaces);
            formatedNum = numeral(num).format(this.numeralFormat);

            return this.numStringPrefix + formatedNum + this.numStringSuffix;
        },
        fillChartData(nginxData) {
            this.chartData.datacollection.datasets = nginxData.data.datasets;
            this.chartData.datacollection.labels = nginxData.data.labels;
            // this.chartData = chartData;
        }
    },
    mounted() {
        //this.formatString = this.formatNumToString(this.givenChartData.data.num);
    },
    computed: {},
    watch: {}
};
</script>
<style scoped>
.container {
    position: relative;
    overflow: scroll;
}

/* .center {
    margin: 0;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
} */
</style>



// WEBPACK FOOTER //
// src/components/dashboard/SingleNumWrapperV2.vue